import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import getStyle from '../utils/getStyle';

const BREAKPOINT_MD = getStyle('breakpoints.md');
const BREAKPOINT_LG = getStyle('breakpoints.lg');

const WYSIWYG = ({config}) => {

    return (
        <WYSIWYG__Section className="-padded--v -padded">
            <WYSIWYG__Inner_Wrapper className="-wrap entry-content">
                <WYSIWYG__Title_Container>
                    <WYSIWYG__Title 
                        dangerouslySetInnerHTML={{__html:config?.title}}
                    />
                </WYSIWYG__Title_Container>
                <WYSIWYG__Content 
                    dangerouslySetInnerHTML={{ __html: config?.wysiwygText }}
                />
            </WYSIWYG__Inner_Wrapper>
        </WYSIWYG__Section>
    );
};

const WYSIWYG__Section = styled.section``;

const WYSIWYG__Inner_Wrapper = styled.div``;

const WYSIWYG__Title_Container = styled.div`
    padding-top: 15px;
    margin: 0 auto;

    @media (min-width: ${BREAKPOINT_MD}) {
        margin: 0;        
    }
`;

const WYSIWYG__Title = styled.h2`
    font-weight: bold;
    font-weight: 900;
    text-transform: uppercase;
`;

const WYSIWYG__Content = styled.p`
    margin-bottom: 20px;
    img.alignleft{
        float: left;
        margin-right: 2em;
    }
    img.alignright{
        float: right;
        margin-right: 2em;
    }
    img.aligncenter{
        clear: both;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
`;

export default WYSIWYG;
